export default __webpack_public_path__ + "static/two-tablets-d0df0203c74ad34d29c3efaf07f61484.png";